'use client';

import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';

const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;
const shouldSendTestError =
  process.env.NEXT_PUBLIC_BUGSNAG_TEST_ERROR === 'true';
const appVersion =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
  process.env.NEXT_PUBLIC_APP_VERSION;
const releaseStage = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV;
const startedFlag = '__scalepracticer_bugsnag_started__';

const initBugsnag = () => {
  if (globalThis.window === undefined || !apiKey) return false;
  if (globalThis.window[startedFlag]) return true;

  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion,
    releaseStage,
  });
  BugsnagPerformance.start({ apiKey });

  if (shouldSendTestError) {
    Bugsnag.notify(new Error('Test error'));
  }

  globalThis.window[startedFlag] = true;
  return true;
};

const BugsnagProvider = ({ children }) => {
  const ErrorBoundary = React.useMemo(() => {
    const started = initBugsnag();
    if (!started) return React.Fragment;

    const reactPlugin = Bugsnag.getPlugin('react');
    return reactPlugin
      ? reactPlugin.createErrorBoundary(React)
      : React.Fragment;
  }, []);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default BugsnagProvider;
